import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CompaniesService {
    constructor(private http: HttpClient) {}

    private companySubject = new BehaviorSubject<any>({});
    company$ = this.companySubject.asObservable();

    updateCompany(company: any) {
        this.companySubject.next(company);
    }

    getCompanies(fields) {
        return this.http.get(`${environment.apiUrl}/companies`, {
            params: fields,
        });
    }

    getSimpleCompanies(disease?: 'cardio' | 'nephro', journeyId?: string) {
        return this.http.get<any>(`${environment.apiUrl}/companies/simple`, {
            params: {
                ...(disease ? { disease } : {}),
                ...(journeyId ? { journeyId } : {}),
            },
        });
    }

    getAllCompanies() {
        return this.http.get<any>(`${environment.apiUrl}/companies/simple`);
    }

    getReferentUsersFromCompany(companyId, fields) {
        return this.http.get<any>(`${environment.apiUrl}/users-referent-company/${companyId}`, { params: fields });
    }
}
